import "./FooterPlate.scss";

export default function FooterPlate({ title, subtitle, items }) {
  const isContacts = title === "Контакты";

  return (
    <div className="footer-plate">
      <div className="footer-plate__header">
        <p className="footer-plate__header-title">{title}</p>
        {subtitle && <p className="footer-plate__header-subtitle">{subtitle}</p>}
      </div>
        <div className="footer-plate__content">
          {items.map((item, index) => (
            <div className="footer-plate__content-container" key={index}>
              {item.title && <p className="footer-plate__content-title">{item.title}</p>}
              {item.to ? <a className={`footer-plate__content-link ${isContacts ? "no-underline" : ""}`} href={item.to} target={item.target || "_self"} onClick={item.onClick}>{item.text}</a> : <p className="footer-plate__content-text">{item.text}</p>}
            </div>
          ))}
      </div>
    </div>
  );
}
